import React from "react";
import Details from "./Details";
import Action from "./Action";
import Summary from "./Summary";

import styles from "./ResultCard.module.scss";

const ResultCard = ({ children, style }) => (
  <section className={styles.base} style={style}>
    <div className={styles.content}>
      {children.find(child => child.type === Summary)}
      {children.find(child => child.type === Details)}
      {children.find(child => child.type === Action)}
    </div>
  </section>
);

ResultCard.Details = Details;
ResultCard.Summary = Summary;
ResultCard.Action = Action;

export default ResultCard;
